/* eslint-disable */
import {lista} from '../../../services/GenericAPI'

const url = 'aux_motivo_contato'

const state = {
  all: []
}

const getters = {
  listaMotivoContato: (state) => {
    return state.all
  }
}

const actions = {
  async setAllMotivoContato ({ commit }) {
    const list = (await lista(url)).data
    commit('SET_MOTIVO_CONTATO', list)
  }
}

const mutations = {
  SET_MOTIVO_CONTATO(state, motivo) {
    state.all = motivo
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
